import { Serializable } from '@/models/core/serializable';
import { store } from '@/store';

export class SchoolGroupTrendAnalysis implements Serializable<SchoolGroupTrendAnalysis> {
  // グロースマインドセットマップ
  growthMindsetMap: GrowthMindsetMap;
  // 心理的安全性
  psychologicalSafety: PsychologicalSafety;
  // 文理傾向
  humanitiesOrSciences: HumanitiesOrSciences;

  constructor() {
    this.growthMindsetMap = undefined;
    this.psychologicalSafety = undefined;
  }

  deserialize(input: any): SchoolGroupTrendAnalysis {
    this.growthMindsetMap = new GrowthMindsetMap().deserialize(input.growthMindsetMap);
    this.psychologicalSafety = new PsychologicalSafety().deserialize(input.psychologicalSafety);
    this.humanitiesOrSciences = new HumanitiesOrSciences().deserialize(input.humanitiesOrSciences);
    return this;
  }
}

export class GrowthMindsetMap implements Serializable<GrowthMindsetMap> {
  latestData: GrowthMindsetMapData[];
  latestTime: Date;
  lastData: GrowthMindsetMapData[];
  lastTime: Date;

  deserialize(input: any): GrowthMindsetMap {
    this.latestData = input.latestData.map((d: GrowthMindsetMapData) => new GrowthMindsetMapData().deserialize(d));
    this.latestTime = input.latestTime;
    this.lastData = input.lastData.map((d: GrowthMindsetMapData) => new GrowthMindsetMapData().deserialize(d));
    this.lastTime = input.lastTime;

    return this;
  }
}

export class GrowthMindsetMapData implements Serializable<GrowthMindsetMapData> {
  student: any;
  xPos: number;
  yPos: number;

  deserialize(input: any): GrowthMindsetMapData {
    this.student = input.student;
    this.xPos = input.xPos;
    this.yPos = input.yPos;
    return this;
  }

  get fullName() {
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      return `${this.student.lastName} ${this.student.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      return `${this.student.firstName} ${this.student.lastName}`;
    }
  }
}

export class PsychologicalSafety implements Serializable<PsychologicalSafety> {
  latestData: TrendScoreDistribution;
  latestMedian: number;
  latestOutlierLowerStudents: any;
  latestOutlierUpperStudents: any;
  lastData: TrendScoreDistribution;
  lastMedian: number;
  lastOutlierLowerStudents: any;
  lastOutlierUpperStudents: any;

  deserialize(input: any): PsychologicalSafety {
    this.latestData = new TrendScoreDistribution().deserialize(input.latestData);
    this.latestMedian = input.latestMedian;
    this.latestOutlierLowerStudents = input.latestOutlierLowerStudents;
    this.latestOutlierUpperStudents = input.latestOutlierUpperStudents;
    this.lastData = new TrendScoreDistribution().deserialize(input.lastData);
    this.lastMedian = input.lastMedian;
    this.lastOutlierLowerStudents = input.lastOutlierLowerStudents;
    this.lastOutlierUpperStudents = input.lastOutlierUpperStudents;
    return this;
  }
}

export class TrendScoreDistribution implements Serializable<TrendScoreDistribution> {
  giftCourseID: number;
  giftCourseTitle: string;
  examDate: Date;
  trendData: trendData[];

  deserialize(input: any): TrendScoreDistribution {
    this.giftCourseID = input.giftCourseID;
    this.giftCourseTitle = input.giftCourseTitle;
    this.examDate = input.examDate;
    this.trendData = [];
    // Echartsのx軸上では、-2<x<2ではなく、-100<x<100の範囲で表示させたいため、変換する
    if (input.trendData && input.trendData.length > 0) {
      //配列でdata,userNameがあるため
      input.trendData.forEach((d: trendData) => {
        const trendData = [this.toDisplayValue(d.data[0]), this.toDisplayValue(d.data[1]), d.data[2]];
        this.trendData.push({
          data: trendData,
          userName: d.userName,
        } as trendData);
      });
    }
    return this;
  }

  toDisplayValue(d: number) {
    return Math.floor(d * 50 * 1000) / 1000;
  }
}

export class trendData implements Serializable<trendData> {
  data: number[];
  userName: string[];

  deserialize(input: any): trendData {
    this.data = input.data;
    this.userName = input.userName;
    return this;
  }
}

export class HumanitiesOrSciences implements Serializable<HumanitiesOrSciences> {
  latestData: TrendScoreDistribution;
  latestMean: number;
  latestStandardDeviation: number;
  lastData: TrendScoreDistribution;
  lastMean: number;
  lastStandardDeviation: number;

  deserialize(input: any): HumanitiesOrSciences {
    this.latestData = new TrendScoreDistribution().deserialize(input.latestData);
    this.latestMean = this.toDisplayValue(input.latestMean);
    this.latestStandardDeviation = this.toDisplayValue(input.latestStandardDeviation);
    this.lastData = new TrendScoreDistribution().deserialize(input.lastData);
    this.lastMean = this.toDisplayValue(input.lastMean);
    this.lastStandardDeviation = this.toDisplayValue(input.lastStandardDeviation);
    return this;
  }

  toDisplayValue(d: number) {
    return Math.floor(d * 50 * 1000) / 1000;
  }
}
